import { TourAttractionsMap } from '@/components/tours/TourAttractionsMap';
import { useTourContext } from '@/pages/tours/useTourContext';
import { Badge, Loading } from '@startupquickstart/frontend';
import { Footprints, MoveRight } from 'lucide-react';

/**
 * Read-only overview of where this tour's attractions sit on the map.
 * When the tour is in `defined` path mode the pins are numbered and
 * connected by a polyline in the order they're walked. In `fastest` mode
 * the pins are unnumbered (mobile picks the order at run-time from the
 * user's location).
 */
export function TourMapTab() {
  const { tour, isLoading } = useTourContext();

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  if (!tour) return null;

  const ordered = tour.pathMode === 'defined';

  return (
    <div className="space-y-4 p-4">
      <div className="flex items-center justify-between gap-2">
        <div>
          <h2 className="text-lg font-medium tracking-tight text-zinc-900">Map</h2>
          <p className="text-sm text-muted-foreground">
            {ordered
              ? 'Stops are numbered and connected in walking order.'
              : 'Stops are shown without an order — mobile picks the path from the user’s location.'}
          </p>
        </div>
        <Badge variant="outline" className="gap-1.5">
          {ordered ? (
            <>
              <MoveRight className="h-3.5 w-3.5" />
              Defined route
            </>
          ) : (
            <>
              <Footprints className="h-3.5 w-3.5" />
              Fastest path
            </>
          )}
        </Badge>
      </div>

      <TourAttractionsMap tourId={tour.id} ordered={ordered} />
    </div>
  );
}
